module.exports = __webpack_public_path__ + "static/media/June2021Newsletter.299f6a0d.pdf";